import styled from 'styled-components';
import * as Tooltip from '@radix-ui/react-tooltip';
import ChevronDownIcon from '@bufferapp/ui/Icon/Icons/ChevronDown';
import { gray, grayDarker } from '@bufferapp/ui/style/colors';
import { fontFamily, fontWeight } from '@bufferapp/ui/style/fonts';

import { Button } from '~/ai/styles/Button';

export const StyledButton = styled(Button)`
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
`;

export const StyledTooltipTrigger = styled(Tooltip.Trigger)`
  border: none;
  background: transparent;
`;

export const StyledTooltipContent = styled(Tooltip.Content)`
  font-family: ${fontFamily};
  font-size: 12px;
  line-height: 14px;
  font-weight: ${fontWeight};
  border-radius: 4px;
  border: none;
  padding: 6px 10px;
  color: white;
  background-color: ${grayDarker};
  z-index: 5000;
  max-width: 200px;
  box-shadow: 2px 2px 10px hsl(0deg 0% 0% / 10%);
`;

export const Loader = styled.span`
  width: 16px;
  height: 16px;
  border: 2px solid ${gray};
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin-right: 4px;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const Arrow = styled(ChevronDownIcon)`
  margin: 0px 6px;
`;
